import { useMemo } from 'react';

import useChordBarsPreview from './useChordBarsPreview';
import { getProgressionChords } from '../utils/diatonicChords';

// I–V–vi–IV: C G Am F in C. A minor key plays the same degrees off its own scale.
const PROGRESSION = [1, 5, 6, 4];
// A song can be given a key before its tempo
const FALLBACK_BPM = 80;

/**
 * A four-bar progression in the song's key, for hearing an instrument or a rhythm style picked
 * where there is no chart yet to play — the song's own defaults in the song form.
 *
 * Takes useChordBarsPreview's options; `key` is the song's key, and with none there is nothing to play.
 */
const useKeyProgressionPreview = ({ key, bpm, ...options }) => {
  const lines = useMemo(() => {
    const chords = key ? getProgressionChords(key, PROGRESSION) : [];

    return chords.length > 0 ? [chords] : [];
  }, [key]);

  return useChordBarsPreview(lines, { ...options, bpm: bpm || FALLBACK_BPM });
};

export default useKeyProgressionPreview;
